import Image from 'next/legacy/image';

export default function CreateAccount() {
  return (
    <li>
      <h3 id="create-account">Create an account with Stackblocks</h3>
      <p>
        <a href="/get-started">Sign up</a> with your email to get a magic login link. Click that
        link in the email and you are logged in to the app.
      </p>
      <Image
        src="/guides/create-account.jpg"
        width={1156}
        height={738}
        alt="screenshot of get started page"
      />
    </li>
  );
}
